var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('oil-cap',{attrs:{"title":"Поставщики","buttons":[
        {name:'создать платеж',route:'coming-payment-supplier'}
    ]}}),_c('v-divider',{staticClass:"my-2"}),_c('oil-table',{attrs:{"keys":[
      {
        text: 'Поставщик',
        value: 'SupplierName',

      },
      {
        text: 'Договор',
        value: 'ContractNumber',

      },
      {
        text: 'счет фактура',
        value: 'InvoiceNumber',
      },
      {
        text: 'Сумма',
        value: 'Amount',
      }
    ],"items":_vm.payments,"paginate":_vm.count,"rowClick":_vm.handleRowClick},on:{"paginateAction":_vm.paginate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }